// ----------------------------------------
// 横スクロール時のナビ追随
// ----------------------------------------
(function($) {
  $(window).on('load', function() {
    var headerHeight = $('.l-header').outerHeight();

    var scrollValue = $(window).scrollTop();
    if (scrollValue >= headerHeight) {
      $('.p-pcNav-wrapper, .l-main').addClass('is-fixed');
    }
    $('.p-pcNav-wrapper.is-fixed').css({
      left: -window.pageXOffset + 'px',
    });
    tracking(headerHeight);
  });

  function tracking(hH) {
    $(window).on('scroll', function() {
      var scrollValue = $(window).scrollTop();
      $('.p-pcNav-wrapper.is-fixed').css({
        left: -window.pageXOffset + 'px',
      });
      if (scrollValue >= hH) {
        $('.p-pcNav-wrapper, .l-main').addClass('is-fixed');
      } else {
        $('.p-pcNav-wrapper, .l-main').removeClass('is-fixed');
      }
    });
  }

})(jQuery);
